import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import fullLogo from '../../assets/images/simpleLogo.jpg';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function WMSCategoryDrawer({
    open,
    onToggle,
    categories,
    selectedCategoryId,
    onSelectCategory,
    homePath = '/wms',
}) {
    return (
        <div
            className={`hidden fixed inset-y-0 left-0 z-[7] box-border bg-white sm:block !transition-none !m-0${
                open ? '' : ' cursor-pointer'
            }`}
            style={{ width: open ? '14rem' : '64px' }}
            onClick={open ? undefined : onToggle}
        >
            <div className='flex relative flex-col h-full !transition-none'>
                <div
                    className='absolute inset-0 pointer-events-none'
                    style={{
                        boxShadow: '1px 0 3px 0 rgb(0 0 0 / 0.1), 1px 0 2px -1px rgb(0 0 0 / 0.1)',
                        clipPath: 'inset(0 -8px 0 0)',
                    }}
                    aria-hidden='true'
                />
                <div
                    className={classNames(
                        'flex overflow-hidden flex-shrink-0 items-center h-16',
                        open ? 'px-6' : 'justify-center px-2'
                    )}
                >
                    <Link to={homePath} className='flex items-center' onClick={(e) => e.stopPropagation()}>
                        <img className='w-auto h-7 max-w-none' src={fullLogo} alt='Pacific Air' />
                    </Link>
                </div>

                {open && (
                    <div className='overflow-y-auto flex-1 pb-4'>
                        <ul>
                            {categories.map((category) => {
                                const isSelected = category.id === selectedCategoryId;
                                return (
                                    <li key={category.id}>
                                        <button
                                            type='button'
                                            onClick={() => onSelectCategory(category)}
                                            className={classNames(
                                                'block w-full text-left px-6 py-1.5 text-base font-medium cursor-pointer !transition-none !transform-none !mt-0 !rounded-none focus:outline-none focus:!shadow-none focus:!z-auto',
                                                isSelected
                                                    ? 'bg-blue-primary text-white'
                                                    : 'text-gray-900 bg-transparent hover:bg-gray-100'
                                            )}
                                        >
                                            {category.name}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}

                <button
                    type='button'
                    onClick={(event) => {
                        event.stopPropagation();
                        onToggle();
                    }}
                    className={classNames(
                        'flex absolute z-10 justify-center items-center w-6 h-6 text-gray-300 bg-white rounded-full border border-gray-300 ring-1 ring-gray-200 cursor-pointer hover:text-gray-400 hover:bg-gray-50 focus:outline-none focus:!shadow-none focus:!z-10 !transition-none !mt-0 !p-0',
                        open ? 'top-1/2 right-0' : 'top-1/2 left-1/2'
                    )}
                    style={{
                        transform: open ? 'translate(50%, -50%)' : 'translate(-50%, -50%)',
                    }}
                    aria-label={open ? 'Collapse menu' : 'Expand menu'}
                >
                    {open ? (
                        <ChevronLeftIcon className='w-3.5 h-3.5' aria-hidden='true' />
                    ) : (
                        <ChevronRightIcon className='w-3.5 h-3.5' aria-hidden='true' />
                    )}
                </button>
            </div>
        </div>
    );
}
